module.exports = __webpack_public_path__ + "static/hi-21d89612a49d5112095f0f4da1227047.jpg";